<template>
  <div class="user-avatar">
    <div
      v-if="user.imageUrl"
      class="user-avatar-image"
      :style="'--avatar-size: ' + avatarSize + 'px'"
    >
      <img :src="user.imageUrl" />
    </div>
    <eg-avatar
      v-else
      :name="user.firstName + ' ' + user.lastName"
      :size="avatarSize"
    />
  </div>
</template>

<script>
import EgAvatar from "./eg/eg_avatar.vue";

export default {
  components: { EgAvatar },

  props: {
    user: {
      type: Object,
      required: true,
    },
    avatarSize: {
      type: Number,
      default: 32,
    },
  },
};
</script>

<style lang="scss" scoped>
.user-avatar-image {
  width: var(--avatar-size, 100%);
  height: var(--avatar-size, 100%);
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
